import { Link } from "react-router-dom";
import { hotContents } from "@/mocks/home";

export default function HotContent() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900 mb-1">
              热门推荐
            </h2>
            <p className="text-foreground-600 text-sm">大家都在看的精彩内容</p>
          </div>
          <Link
            to="/category/movie"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotContents.map((item) => (
            <Link
              key={item.id}
              to={`/article/${item.slug}`}
              className="group block rounded-xl overflow-hidden bg-background-50 transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  title={`${item.title} - ${item.category}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
                    {item.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/80 to-transparent p-3">
                  <span className="text-white/80 text-xs">{item.year}</span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-1.5 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
                  {item.title}
                </h3>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                    {item.category}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}